module.exports = __webpack_public_path__ + "static/bora_ld_white_FA-984d1faac1a6b10fe001532cb95732eb.png";